export default __webpack_public_path__ + "static/media/sketch.bde95eda.svg";